<template>
  <v-footer app fixed clipped-bottom color="primary darken-2" dark class="pa-1" v-if="showBar">
    <footer class="footer text-center d-block text-caption"><v-icon v-if="message">notification_important</v-icon> {{ message }}</footer>
  </v-footer>
</template>

<script>
export default {
  name: "NotificationBar",
  data() {
    return {
      message: "",
      notifications: [],
      seconds: 5000,
      handleSetTimeout1:  null,
      handleSetTimeout2:  null,
    }
  },
  computed: {
    showBar() {
      return this.$store.getters["notification/showNotificationBar"]
    }
  },
  watch: {
    showBar: {
      handler: function(val, oldVal) {
        if (val) {
          this.fetchActiveNotifications()
          if (this.notifications) {
            this.displayMessage()
          }
        } else {
          this.notifications = []
          clearTimeout(this.handleSetTimeout1)
          clearTimeout(this.handleSetTimeout2)
        }
      }
    }
  },
  methods: {
    fetchActiveNotifications() {
      this.notifications = this.$store.getters["notification/activeNotifications"]
    },
    displayMessage() {
      let vm = this
      this.notifications.forEach(async (item, index) => {
        vm.handleSetTimeout1 = setTimeout(function() {
          vm.message = item.header + " | " + item.body

          vm.handleSetTimeout2 = setTimeout(function() {
            if(index == vm.notifications.length - 1) {
              vm.fetchActiveNotifications();
              vm.displayMessage()
            }
          }, vm.seconds)
        }, vm.seconds * index)
      })
    }
  }
}
</script>
